import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SitecoreJssForm from '../SitecoreJssForm/index';
import { updateFields } from '../ReduxImpl/actions/index';

const JssFormDisplay = ({ fields, history }) => {
  const dispatch = useDispatch();

  const fieldsData = useSelector((state: any) => {
    // SetUniqueId(value => value + 1);
    return state.fields;
  });

  const JssFormKey = useSelector((state: any) => {
    // SetUniqueId(value => value + 1);
    return state.JssFormKey;
  });

  useEffect(() => {
    dispatch(updateFields(fields));
  }, [fields]);

  return (
    <div key={JssFormKey}>
      <SitecoreJssForm fields={fieldsData} />
    </div>
  );
};

export default JssFormDisplay;
